


















import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class CloseDateModal extends Vue {
  @Prop({ required: true }) item!: {
    id: string;
    date: string;
    start: string;
  };

  show() {
    (this.$refs.modal as any).show();
  }

  hide() {
    (this.$refs.modal as any).hide();
  }

  create() {
    if (
      new Date(this.item.date).getTime() < new Date(this.item.start).getTime()
    ) {
      alert("指定完了日が不正です。");

      return;
    }

    if (!confirm("完了日になりましたら、現場を終了してもよろしでしょうか？")) {
      return;
    }
    this.$emit("handleSave", this.item);
    this.hide();
  }
}
